import React, { useEffect, useState } from 'react';
import { Plus, X, Search, RefreshCw, Download } from 'lucide-react';
import styles from './MileageAnalysisTab_bus.module.css';
import '../style.css';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import { useVehicleData } from './context';
import Select from 'react-select'
import DownloadVehicleInfoPDF from './DownloadDriverDetails';



const VehicleDetailsCard = ({ /* selectedVehicles, onAddVehicle, */ filterData, /* onFilterChange, */ onVehicleSelect, /* bestDayDate,  */benchmarkType }) => {
  // const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [localSelectedVehicles, setLocalSelectedVehicles] = useState([]);
  // const [searchTerm, setSearchTerm] = useState('');
  // const [currentSlot, setCurrentSlot] = useState(0);
  // const [selectedVehicleInPopup, setSelectedVehicleInPopup] = useState(null);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [options, setOptions] = useState([])



  const { GlobalData, setGlobalData } = useVehicleData();
  // const [allVins, setAllVins] = useState([])

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis/mileage_analysis_all_vin_registration_number`,
        body: {
          filterdata: {
            ...filterData,
          }
        }
      },
      (res) => { //  { value: 'chocolate', label: 'Chocolate' },
        let data = res.map((item, index) => ({ value: item.key.vehicleId, label: item.key.vehicleId + " / " + item.key.vehicle_registration_number, regNo: item.key.vehicle_registration_number, id: index + 1 }))
        // setAllVins(data)
        setOptions(data)
      }
    );
  }, [filterData])


  // Filter vehicles based on search term - only show when search term exists
  // const filteredVehicles = searchTerm.trim()
  //   ? allVins.filter(vehicle =>
  //     vehicle.vehicleId.toLowerCase().includes(searchTerm.toLowerCase())
  //   )
  //   : [];

  // const handleAddVehicleClick = (slotIndex) => {
  //   setCurrentSlot(slotIndex);
  //   setIsPopupOpen(true);
  //   setSearchTerm('');
  //   setSelectedVehicleInPopup(null); // Reset selected vehicle when opening popup
  // };

  // const handleVehicleItemClick = (vehicle) => {
  //   setSelectedVehicleInPopup(vehicle);
  // };

  // const handleAddSelectedVehicle = () => {
  //   if (!selectedVehicleInPopup) return;

  //   const newSelectedVehicles = [...localSelectedVehicles];

  //   newSelectedVehicles[currentSlot] = selectedVehicleInPopup;
  //   setLocalSelectedVehicles(newSelectedVehicles);

  //   setIsPopupOpen(false);
  //   setSelectedVehicleInPopup(null);

  //   // Call the parent callback to handle vehicle selection
  //   if (onVehicleSelect) {
  //     onVehicleSelect({ firstVinNo: newSelectedVehicles?.[0], secondVinNo: newSelectedVehicles?.[1] });
  //   }

  //   if (onAddVehicle) {
  //     onAddVehicle(selectedVehicleInPopup.name);
  //   }
  // };

  // const handleRefresh = (slotIndex) => {
  //   const newSelectedVehicles = [...localSelectedVehicles];
  //   newSelectedVehicles[slotIndex] = null;
  //   setLocalSelectedVehicles(newSelectedVehicles);

  //   if (onVehicleSelect) {
  //     onVehicleSelect(null);
  //   }
  // };

  // const handleDownloadReport = (vehicle) => {
  //   alert(`Downloading driver's report card for ${vehicle.name}`);
  // };

  // const clearSelection = (slotIndex) => {
  //   const newSelectedVehicles = [...localSelectedVehicles];
  //   newSelectedVehicles[slotIndex] = null;
  //   setLocalSelectedVehicles(newSelectedVehicles);

  //   if (onVehicleSelect) {
  //     onVehicleSelect(null);
  //   }
  // };

  // const closePopup = () => {
  //   setIsPopupOpen(false);
  //   setSearchTerm('');
  //   setSelectedVehicleInPopup(null);
  // };


  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? '#92afd5' : '#ccc', // Blue when focused
      boxShadow: state.isFocused ? '0 0 0 1px #92afd5' : 'none',
      '&:hover': {
        borderColor: '#92afd5'
      },
      minHeight: '38px',
      textAlign: 'left',

    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? '#f0f8ff' // Light blue on hover
        : state.isSelected
          ? '#92afd5' // Blue on selected
          : 'white',
      color: state.isSelected ? 'black' : 'black',
      '&:hover': {
        backgroundColor: '#e6f0ff', // Slightly lighter blue
      },
      textAlign: 'left',
      fontSize: "12px",

    }),

    singleValue: (provided) => ({
      ...provided,
      color: '#92afd5', // Selected text color
      // fontWeight: 'bold',
    }),

    menu: (provided) => ({
      ...provided,
      zIndex: 9999 // Ensure it stays above modals or other components
    }),
    // menuList: (provided) => ({
    //   ...provided,
    //   maxHeight: '200px',
    //   overflowY: 'auto',
    // }),
  };

  const [vinNo1, setVinNo1] = useState()
  const [vinNo2, setVinNo2] = useState()
  const [primaryVehicle, setPrimaryVehicle] = useState({})
  const [secondaryVehicle, setSecondaryVehicle] = useState({})

  function handleChange(value) {
    setVinNo1(value)
  }
  function handleChange2(value) {
    setVinNo2(value)
  }

  function addPrimaryVehicle() {
    setPrimaryVehicle(vinNo1)
    onVehicleSelect(prev => ({ ...prev, firstVinNo: { vehicleId: vinNo1?.value }, }));
  }

  function addSecondaryVehicle() {
    setSecondaryVehicle(vinNo2)
    onVehicleSelect(prev => ({ ...prev, secondVinNo: { vehicleId: vinNo2?.value }, }));
  }
  return (
    <>
      <div className="row mb-4">
        <div className="col-12">
          <div className={`${styles.vehicleContainer} px-4`}>
            {/* Vehicle Details Row */}
            <div className="row align-items-center">
              <div className="col-3">
                <div className={`d-flex align-items-center px-2 ${styles.vehicleDetailsSection}`}>
                  <h6 className={`mb-0 ${styles.vehicleDetailsTitle}`}>
                    Vehicle Details :
                  </h6>
                </div>
              </div>

              {/* First Add Vehicle Section */}
              <div className="col-3">
                <div
                  className={`d-flex align-items-center justify-content-center px-4 position-relative ${styles.addVehicleSlot}`}
                  style={{ minHeight: '80px' }}
                >
                  {primaryVehicle?.value ? (
                    <div className="d-flex align-items-center justify-content-between w-100">
                      <small className={styles.selectedVehicleText}>
                        {primaryVehicle?.value}
                        <br />
                        {primaryVehicle?.regNo}

                      </small>
                      <div className="d-flex gap-2 ms-2">
                        <button
                          // onClick={() => handleAddVehicleClick(0)}
                          className={`btn btn-sm ms_btn border-0 ${styles.actionButton}`}
                          title="Refresh"
                          data-toggle="modal" data-target={"#AddVehicle1"}
                        >
                          <RefreshCw size={14} color="#666" />
                        </button>
                        {/* <button
                          // onClick={() => handleDownloadReport(localSelectedVehicles[0])}
                          className={`btn btn-sm ms_btn border-0 ${styles.actionButton}`}
                        // data-toggle="modal" data-target={"#Download_MSbus_Analysis"}
                        > */}
                        {/* <Download size={14} color="#666" /> */}
                        <DownloadVehicleInfoPDF />
                        {/* </button> */}
                      </div>
                    </div>
                  ) : (
                    <div
                      className={`d-flex align-items-center ${styles.addVehicleContent}`}
                      data-toggle="modal" data-target={"#AddVehicle1"}
                    // onClick={() => handleAddVehicleClick(0)}
                    >
                      <div className={`d-flex align-items-center justify-content-center me-2 ${styles.addVehicleIcon}`}>
                        <Plus size={12} color="white" />
                      </div>
                      Add Vehicle
                    </div>
                  )}
                </div>
              </div>

              {/* Best Driven Day Parameters Section */}
              <div className="col-3">
                <div
                  className={`d-flex align-items-center justify-content-center px-4 ${styles.bestDaySection}`}
                  style={{ minHeight: '80px' }}
                >
                  <p className={`mb-0 text-muted text-center ${styles.bestDayText}`}>
                    {GlobalData?.bestVehicle
                      ? `This table represents best driven day for selected vehicle - ${GlobalData?.bestVehicle}`
                      : "Best driven day parameters for selected vehicle will appear here"
                    }
                  </p>
                </div>
              </div>

              {/* Second Add Vehicle Section */}
              <div className="col-3">
                <div
                  className={`d-flex align-items-center justify-content-center px-4 position-relative ${localSelectedVehicles[1] ? styles.selectedVehicleSlot : styles.addVehicleSlot}`}
                  style={{ minHeight: '80px' }}
                >
                  {benchmarkType == "National" ?
                    <div className=" w-100">
                      <div className={styles.selectedVehicleText} style={{ fontSize: "11px" }}>
                        {GlobalData?.nationalVehicleDetails?.vehicleId}
                      </div>
                      <div className={styles.selectedVehicleText} style={{ fontSize: "11px" }}>
                        {GlobalData?.nationalVehicleDetails?.vehicle_registration_number}
                      </div>
                    </div>
                    : <></>}
                  {benchmarkType == "Depot" ?
                    <div className=" w-100">
                      <div className={styles.selectedVehicleText} style={{ fontSize: "11px" }}>
                        {GlobalData?.depoVehicleDetails?.vehicleId}
                      </div>
                      <div className={styles.selectedVehicleText} style={{ fontSize: "11px" }}>
                        {GlobalData?.depoVehicleDetails?.vehicle_registration_number}
                      </div>
                    </div>
                    : <></>}
                  {benchmarkType == "Custom" ? secondaryVehicle?.value ? (
                    <div className="d-flex align-items-center justify-content-between w-100">
                      <small className={styles.selectedVehicleText}>
                        {secondaryVehicle?.value}
                        <br />
                        {secondaryVehicle?.regNo}
                      </small>
                      <div className="d-flex gap-2 ms-2">
                        <button
                          data-toggle="modal" data-target={"#AddVehicle2"}
                          // onClick={() => handleAddVehicleClick(1)}
                          className={`btn btn-sm ms_btn border-0 ${styles.actionButton}`}
                          title="Refresh"
                        >
                          <RefreshCw size={14} color="#666" />
                        </button>
                        {/* <button
                          // onClick={() => handleDownloadReport(localSelectedVehicles[1])}
                          className={`btn btn-sm ms_btn border-0 ${styles.actionButton}`}
                          title="Download Driver's Report Card"
                        >
                          <Download size={14} color="#666" />
                        </button> */}
                      </div>
                    </div>
                  ) : (

                    <div
                      data-toggle="modal" data-target={"#AddVehicle2"}
                      className={`d-flex align-items-center ${styles.addVehicleContent}  ${!primaryVehicle?.value ? styles.disabledTab : ''} `}
                    >
                      <div className={`d-flex align-items-center justify-content-center me-2 ${styles.addVehicleIcon}`}>
                        <Plus size={12} color="white" />
                      </div>
                      Add Vehicle
                    </div>
                  ) : <></>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Popup Modal */}
      <div id="AddVehicle1" className="modal fade" role="dialog">
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header fw-bold fs-5 py-2" style={{ color: "#4e555f" }}>
              Add Vehicle
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>

            <div className="modal-body p-0"
              style={{
                overflow: 'auto',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                height: "300px",
                overflowY: "scroll",
              }}
            >
              <div className='mx-3 mt-2'>
                <Select
                  options={options}
                  value={vinNo1}
                  onChange={handleChange}
                  styles={customStyles}
                  placeholder="Search vehicle..."
                  noOptionsMessage={() => isLoading ? "Loading..." : "No vehicles found"}
                />
              </div>
              {
                primaryVehicle.value ?
                  <div className='mx-3 mt-4 card p-2 text-start'>
                    <div className='text-muted fw-bold mb-2' style={{ fontSize: "12px" }}>Vehicle Details</div>
                    <p className='mb-1 fw-bold'>{primaryVehicle?.value}</p>
                    <p className='mb-1 fw-bold'>{primaryVehicle?.regNo}</p>
                  </div>
                  : <div className='mx-3 mt-4 p-2'>
                    <div className='text-muted fw-bold mb-2' style={{ fontSize: "12px" }}>No Vehicle Select</div>
                  </div>
              }
            </div>
            <div className="modal-footer">
              {
                vinNo1?.value ?
                  <button type="button" className="btn ms_btn btn-default MS_button" data-dismiss="modal" onClick={addPrimaryVehicle} >
                    Add Vehicle
                  </button> : <></>
              }

            </div>
          </div>
        </div>
      </div>

      <div id="AddVehicle2" className="modal fade" role="dialog">
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header fw-bold fs-5 py-2" style={{ color: "#4e555f" }}>
              Add Vehicle
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>

            <div className="modal-body p-0"
              style={{
                overflow: 'auto',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                height: "300px",
                overflowY: "scroll",
              }}
            >
              <div className='mx-3 mt-2'>
                <Select
                  options={options}
                  value={vinNo2}
                  onChange={handleChange2}
                  styles={customStyles}
                  placeholder="Search vehicle..."
                />
              </div>
              {
                secondaryVehicle?.value ?
                  <div className='mx-3 mt-4 card p-2 text-start'>
                    <div className='text-muted fw-bold mb-2' style={{ fontSize: "12px" }}>Vehicle Details</div>
                    <p className='mb-1 fw-bold'>{primaryVehicle?.value}</p>
                    <p className='mb-1 fw-bold'>{primaryVehicle?.regNo}</p>
                  </div>
                  : <div className='mx-3 mt-4 p-2 '>
                    <div className='text-muted fw-bold mb-2' style={{ fontSize: "12px" }}>No Vehicle Select</div>
                  </div>
              }
            </div>
            <div className="modal-footer">
              {
                vinNo2?.value ?
                  <button type="button" className="btn ms_btn btn-default MS_button" data-dismiss="modal" onClick={addSecondaryVehicle} >
                    Add Vehicle
                  </button> : <></>
              }

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VehicleDetailsCard;